import gsap from 'gsap';

export class Count {
    private parts: string[] = [];
    private newParts: string[] = [];
    private numberPartIndexes: number[] = [];
    private trigger: any;
    private tween: any = null;
    private isDestroyed: boolean = false;
    private cachedHTML: string = '';

    constructor(private element: HTMLElement, private duration: number = 0.5) {
        this.init();
    }

    init(): void {
        const string = this.element.textContent || '';
        this.parts = string.split(/(\d+(\.\d+)?)/g).filter(x => x !== undefined && x !== '');
        this.newParts = [...this.parts];
        this.numberPartIndexes = this.parts.reduce<number[]>((indexes, part, index) => {
            if (!Number.isNaN(parseFloat(part))) {
                indexes.push(index);
            }

            return indexes;
        }, []);
        this.cachedHTML = '';

        this.trigger = window.scrollTrigger.create({
            trigger: this.element,
            start: "top bottom",
            end: "center top",
            toggleActions: "play none none none",
            markers: false,
            onEnter: () => this.startAnimation(),
        });
    }

    private startAnimation(): void {
        if (this.isDestroyed) return;

        // Kill any existing tween
        if (this.tween) {
            this.tween.kill();
        }

        this.element.style.willChange = 'contents';

        // Create an object to animate progress from 0 to 1
        const animationObj = { progress: 0 };

        this.tween = gsap.to(animationObj, {
            progress: 1,
            duration: this.duration,
            onUpdate: () => this.animateProgress(animationObj.progress),
            onComplete: () => {
                this.trigger?.kill();
                this.element.style.willChange = 'auto';
            }
        });
    }

    private animateProgress(progress: number): void {
        if (this.isDestroyed) return;

        // Update all number parts
        this.numberPartIndexes.forEach((i) => {
            const number = parseFloat(this.parts[i]);
            const strLength = this.parts[i].length;
            this.newParts[i] = Math.round(number * progress).toString().padStart(strLength, '0');
        });

        // Only update DOM if content has changed
        const updatedHTML = this.newParts.join('');
        if (this.cachedHTML !== updatedHTML) {
            this.cachedHTML = updatedHTML;
            this.element.textContent = updatedHTML;
        }
    }

    destroy(): void {
        if (this.isDestroyed) return;

        this.isDestroyed = true;

        if (this.tween) {
            this.tween.kill();
            this.tween = null;
        }

        this.trigger?.kill();

        this.element.style.willChange = 'auto';
    }
}


